import script from "./FamilyGroupManage.vue?vue&type=script&lang=ts&setup=true"
export * from "./FamilyGroupManage.vue?vue&type=script&lang=ts&setup=true"

import "./FamilyGroupManage.vue?vue&type=style&index=0&id=8f45cfb8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f45cfb8"]])

export default __exports__